{
  "selectAsField": "Seleccionar \"{value}\" como {fieldName}",
  "typeToSearchField": "Escribe para buscar un {fieldName}",
  "licenseFieldLabel": "Seleccionar placa (p. ej. 215BG2)",
  "licenseFieldName": "Placa",
  "licensePlaceholder": "Buscar por placa",
  "dotFieldLabel": "Seleccionar número DOT",
  "dotFieldName": "Número DOT",
  "dotPlaceholder": "Buscar por número DOT"
}
